// extracted by mini-css-extract-plugin
module.exports =  {"container":"e3afc254ff--container--Mc5aa","rating":"e3afc254ff--rating--v2Lek","details":"e3afc254ff--details--z2NmG","invisible":"e3afc254ff--invisible--WyKOr"};